export const handleClearLocalStorage = () => {
  localStorage.clear();
};